import translations from '../../components/location/ts/no-NO';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('no-NO', translations);
